import {GitHubAvatar} from '@github-ui/github-avatar'
import {testIdProps} from '@github-ui/test-id-props'
import {useClickAnalytics} from '@github-ui/use-analytics'
import {IconButton, Spinner} from '@primer/react'

import {analyticsCategory} from './constants'
import styles from './GlobalNavUserMenu.module.css'

export function GlobalNavUserMenuToggle({
  owner,
  ref,
  open,
  setOpen,
  isLoading,
  onIntent,
}: {
  owner: {
    login: string
    name: string
    avatarUrl: string
  }
  ref?: React.Ref<HTMLButtonElement>
  open: boolean
  setOpen: (open: boolean) => void
  isLoading?: boolean
  /** Called when the user shows intent to open the menu (hover, focus, press or click). */
  onIntent?: () => void
}) {
  const {sendClickAnalyticsEvent} = useClickAnalytics()

  const label = `${open ? 'Close' : 'Open'} user navigation menu`
  return (
    <div className={styles.container}>
      <IconButton
        ref={ref}
        className={styles.anchor}
        variant="invisible"
        icon={() => <GitHubAvatar size={32} alt={owner.name ?? 'User avatar'} src={owner.avatarUrl} />}
        aria-label={label}
        aria-haspopup="menu"
        onMouseEnter={onIntent}
        onFocus={onIntent}
        onPointerDown={onIntent}
        onClick={() => {
          onIntent?.()
          setOpen(!open)
          sendClickAnalyticsEvent({category: analyticsCategory, action: 'USER_NAV_MENU_TOGGLE', label})
        }}
        data-login={owner.login}
        {...testIdProps('global-nav-user-menu-toggle')}
      />
      {isLoading && open && (
        <div className={styles.overlay}>
          <Spinner size="small" />
        </div>
      )}
    </div>
  )
}
